const state = {
  user: null,             // { userId, householdId, role, expiresAt }
  locale: 'en',
  locales: ['en', 'de'],
  t: {},                  // locale dict
  household: null,        // result of GET /household
  inventory: null,        // result of GET /inventory
  quickCatalog: null,
  units: null,            // result of GET /api/v1/units
  config: null,           // result of GET /api/v1/config — { ocr_adapter }
  inventoryQuery: '',     // persisted search filter for the inventory page
};

const listeners = new Set();

export function getState() { return state; }
export function setState(patch) {
  Object.assign(state, patch);
  for (const l of listeners) l(state);
}
export function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
